import { render, staticRenderFns } from "./OrganizationLogo.vue?vue&type=template&id=b5a167e6"
import script from "./OrganizationLogo.vue?vue&type=script&lang=ts"
export * from "./OrganizationLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports